<template>
  <div class="client-m">
    <div class="m-top-div">
      <div class="m-top">
        <van-checkbox  v-model="newStatus" @change="toSetStatus(newStatus)">
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? inactiveIcon : activeIcon" />
          </template>
        </van-checkbox>
      </div>
      <div class="client-info">
        <img class="header-img" :src="headerImg" alt />
        <div class="info-name">{{username}}</div>
        <div class="info-phone">{{phone}}</div>
      </div>
    </div>
    <ul class="ul-l">
      <li
        @click="checkLi(item)"
        :class="linkLi==item ? 'li-l check-li':'li-l'"
        v-for="(item,index) in liList"
        :key="index"
      >{{item}}</li>
    </ul>
    <div class="client-c">
      <!-- <material v-if="linkLi=='客户资料'"></material> -->
      <Track v-if="linkLi=='访问轨迹'" :stepList='stepList'></Track>
      <order v-if="linkLi=='客户订单'" :orderList='orderList'></order>
    </div>
  </div>
</template>

<script>
// import material from './material.vue'
import URLTB from "@/api/apiTB";
import Track from './track.vue'
import order from './order.vue'
export default {
  components: { Track, order },
  data() {
    return {
      activeIcon: require('@/assets/publicImg/checkbox0.png'),
      inactiveIcon: require('@/assets/publicImg/checkbox1.png'),
      attention:null,
      newStatus:null,
      liList: ['访问轨迹', '客户订单'],
      linkLi: '访问轨迹',
      stepList:[],
      orderList:[],
      headerImg:require('@/assets/publicImg/header.png'),
      phone:'',
      username:''
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    checkLi(item) {
      this.linkLi = item
    },
    getData() {
      let data = {
        agentUserId: localStorage.getItem('userid'),
        userId: this.$route.query.userId
      }
      this.$fetchGet(URLTB.clientsDetail.url, data).then(res => {
        this.attention=res.data.data.attention
        if(this.attention=='0'){
          this.newStatus=false
        }else{
          this.newStatus=true
        }
        this.stepList = res.data.data.foot
        this.orderList=res.data.data.orders
        this.headerImg=res.data.data.headImg
        this.phone=res.data.data.phoneNo
        this.username=res.data.data.username
      })
    },
    toSetStatus(newStatus){
      if (newStatus) {
        this.attention = '1'
      } else {
        this.attention = '0'
      }
      let data = {
        agentUserId: localStorage.getItem('userid'),
        cusUserId: this.$route.query.userId,
        attention: this.attention
      }
      this.$fetchPost(URLTB.clientsAttention.url, this.$toFormData(data)).then(res => {
        if (res.data.code == 20000) {
          console.log(res);
        }
        // this.liList=res.data.data
        // this.checkLi=res.data.data[0].type
      })
    }
  }
}
</script>

<style lang="less" scoped>
.client-m {
  height: 100vh;
  overflow: scroll;
  background: #fff;
  font-family: Source Han Sans CN;
  .m-top-div {
    .m-top {
      width: 375px;
      height: 45px;
      background: url("./img/bg2.png") no-repeat 50%;
      background-size: 100% 100%;
      .van-checkbox {
        height: 45px;
        line-height: 45px;
        justify-content: flex-end;
        padding-right: 25px;
        .img-icon {
          width: 15px;
          height: 13px;
        }
      }
    }
    .client-info {
      margin-top: -23px;
      text-align: center;
      color: #333333;
      .header-img {
        width: 45px;
        height: 45px;
        border-radius: 50%;
      }
      .info-name {
        font-size: 14px;
        font-weight: 500;
      }
      .info-phone {
        margin-top: 2px;
        font-size: 9px;
        font-weight: 400;
      }
    }
  }
  ul {
    width: 355px;
    margin: 17px auto auto;
    display: flex;
    .li-l {
      width: 178px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      background: url("./img/bg3.png") no-repeat 50%;
      background-size: 100% 100%;
    }
    .check-li {
      border-bottom: 1px solid #fc6e09;
    }
  }
  .client-c {
    width: 355px;
    margin: 10px auto auto;
  }
}
</style>